// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"92751c3f","239":"60216727","344":"e349307c","451":"60a6b6ed","455":"8a5cd61b","809":"70bc2cbd","977":"ffd0d9da"}[chunkId] + ".chunk.js";
};